import { Component, Inject } from '@angular/core';

import { CONTAINER_MODE, ContainerModes } from '®shared/container-structure';

@Component({
  selector: 'rl-view-list-as-student',
  templateUrl: './view-list-as-student.component.html',
})
export class ViewListAsStudentComponent {
  containerModes = ContainerModes;
  constructor(
    @Inject(CONTAINER_MODE) public currentContainerMode: ContainerModes,
  ) {}
}
